import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { navigate } from "@gatsbyjs/reach-router";
import { useAuthState } from "_ReactContext/AuthContext";
import useGetMetadata from "customHooks/useGetMetadata";
import { Icon } from "@material-ui/core";
import {
    useCompleoSimpleList,
    actionsTableFunction
} from "customHooks/useCompleoSimpleList";
import useActionsTable from "./components/useActionsTable";
import RightButtonList from "./components/RightButtonList";
import useScheduleTemplate from "../../customHooks/useCompleoForm/Inputs/ScheduleData/useScheduleTemplate";

const ScheduleTemplateList = (props: any) => {
    const moduleName = "SCHEDULETEMPLATELIST";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });
    const scheduleTemplateData = useScheduleTemplate();
    const [metadata] = useGetMetadata(moduleName);
    const listAddress = "/scheduletemplate/list";
    const { company } = useAuthState();
    const actions: actionsTableFunction = useActionsTable(company.companyId, t);

    const [renderTable, finished] = useCompleoSimpleList(
        t,
        metadata,
        listAddress,
        "post",
        {
            companyId: company.companyId
            // totalFakeDataMultiply: 650
        },
        actions
    );

    let compRetorno: null | JSX.Element = <Loading />;
    const ready = readyTranslation && finished && scheduleTemplateData.ready;
    if (ready) {
        compRetorno = renderTable();
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="lg"
                RightButtonComponent={
                    <RightButtonList
                        t={t}
                        options={scheduleTemplateData.typesOfEmailList}
                    />
                }
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default ScheduleTemplateList;
